import Styles from "./PlaceHolder.module.scss";
import classnames from "classnames"


const PlaceHolder = () => {
    return (
        <div className={classnames(Styles.container, "solid_bg")}>
            Only active options are
            <br />
            <div className={Styles.option}>
                -Display
            </div>
            <div className={Styles.option}>
                -Themes
            </div>
            <div className={Styles.option}>
                -Wallpapers and Styles
            </div>
            <div className={Styles.option}>
                -About Phone
            </div>
        </div>
    )
}

export default PlaceHolder
